import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';

function Register() {
    const [formData, setFormData] = useState({
        username: '',
        password: '',
        confirmPassword: '',
        email: '',
        first_name: '',
        last_name: ''
    });
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { register } = useAuth();
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (formData.password !== formData.confirmPassword) {
            setError('Лозинките не се совпаѓаат');
            return;
        }

        if (formData.password.length < 8) {
            setError('Лозинката мора да биде најмалку 8 карактери');
            return;
        }

        setIsLoading(true);

        try {
            const { confirmPassword, ...userData } = formData;
            await register(userData);
            navigate('/');
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <h1>Crypto<span className="brand-accent">Vision</span></h1>
                    <p>Креирајте нов профил</p>
                </div>
                {error && <div className="alert alert-error">{error}</div>}
                <form onSubmit={handleSubmit} className="login-form">
                    <div className="form-group">
                        <label htmlFor="username">Корисничко име *</label>
                        <input
                            id="username"
                            name="username"
                            type="text"
                            value={formData.username}
                            onChange={handleChange}
                            required
                            disabled={isLoading}
                            placeholder="Внесете корисничко име"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="email">Е-пошта</label>
                        <input
                            id="email"
                            name="email"
                            type="email"
                            value={formData.email}
                            onChange={handleChange}
                            disabled={isLoading}
                            placeholder="user@example.com"
                        />
                    </div>
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="first_name">Име</label>
                            <input
                                id="first_name"
                                name="first_name"
                                type="text"
                                value={formData.first_name}
                                onChange={handleChange}
                                disabled={isLoading}
                                placeholder="Име"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="last_name">Презиме</label>
                            <input
                                id="last_name"
                                name="last_name"
                                type="text"
                                value={formData.last_name}
                                onChange={handleChange}
                                disabled={isLoading}
                                placeholder="Презиме"
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Лозинка *</label>
                        <input
                            id="password"
                            name="password"
                            type="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                            disabled={isLoading}
                            placeholder="Најмалку 8 карактери"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="confirmPassword">Потврди лозинка *</label>
                        <input
                            id="confirmPassword"
                            name="confirmPassword"
                            type="password"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            required
                            disabled={isLoading}
                            placeholder="Повторете ја лозинката"
                        />
                    </div>
                    <button
                        type="submit"
                        className="button button-primary login-button"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Регистрација...' : 'Регистрирај се'}
                    </button>
                </form>
                <div className="login-footer">
                    <p>
                        Веќе имате профил? <Link to="/login">Најавете се</Link>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Register;
